import React, { createContext, useState, useContext, useCallback, useMemo } from 'react';
import { adminAPI } from '../services/api';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) throw new Error('useAdmin debe usarse dentro de AdminProvider');
  return context;
};

export const AdminProvider = ({ children }) => {
  const [adminStats, setAdminStats] = useState({
    total_users: 0, active_users: 0, total_gestores: 0, total_premium: 0,
    total_products: 0, total_categories: 0, monthlyGrowth: 0,
    newUsersToday: 0, avgCommission: 0, conversionRate: 0,
  });
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [loading, setLoading] = useState(false);

  const realtimeData = useMemo(() => ({
    currentVisitors: 0,
    transactionsPerMinute: 0,
    systemLoad: 0,
    memoryUsage: 0,
  }), []);

  const loadStats = useCallback(async () => {
    try {
      const res = await adminAPI.getStats();
      const data = res.data;
      setAdminStats({
        total_users: data.total_users || 0,
        active_users: data.active_users || 0,
        total_gestores: data.total_gestores || 0,
        total_premium: data.total_premium || 0,
        total_products: data.total_products || 0,
        total_categories: data.total_categories || 0,
        totalUsers: data.total_users || 0,
        activeUsers: data.active_users || 0,
        totalCommissions: data.totalCommissions || 0,
        pendingPayouts: data.pendingPayouts || 0,
        monthlyGrowth: data.monthlyGrowth || 0,
        newUsersToday: data.newUsersToday || 0,
        avgCommission: data.avgCommission || 0,
        conversionRate: data.conversionRate || 0,
      });
    } catch { }
  }, []);

  const loadUsers = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const res = await adminAPI.getUsers(params);
      setUsers(res.data.users);
      setTotalUsers(res.data.total);
    } catch { }
    finally { setLoading(false); }
  }, []);

  const updateUserStatus = async (userId, data) => {
    await adminAPI.updateUser(userId, data);
    await loadUsers();
  };

  const value = { adminStats, realtimeData, users, totalUsers, loading, loadStats, loadUsers, updateUserStatus };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
};
